module.exports = __webpack_public_path__ + "img/a911ac3e6a26302023326252b9d22c5f.png";